import queryDetails from './queryDetails'

export const queryDetailsService = queryDetails
